import React from 'react'
import { useTranslation } from 'react-i18next'

import { ReactComponent as BrokenPencil } from '../../../../assets/icons/broken-pencil.svg'

import useStyles from './styles'

// this component should avoid using other shared components and theme styles to avoid additional crashing
function AppCrashedInfo() {
  const { t } = useTranslation()
  const classes = useStyles()

  return (
    <div className={classes.infoContainer}>
      <BrokenPencil />
      <h3 className={classes.title}>{t('Sorry, something went wrong')}</h3>
      <div className={classes.description}>{t('We have alerted our team and will fix it as soon as possible')}</div>
    </div>
  )
}

export default AppCrashedInfo
